export default __webpack_public_path__ + "static/media/other13.ade705fa.webp";